/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
//@import BaseMoserObject (loadtime) // superclass

/**
 * Spec that will be used to generate metric definitions
 * @author  AlanTran
 */
export default class MetricGeneratorSpec extends BaseMoserObject{

	facts = null;

	attributes = null;

	traversalPath = null;



	constructor(facts, attributes, traversalPath) {
		super();
		this.facts = facts;
		this.attributes = attributes;
		this.traversalPath = traversalPath;
	}

	getFacts() {
		return this.facts;
	}

	getAttributes() {
		return this.attributes;
	}

	getTraversalPath() {
		return this.traversalPath;
	}

	isEmpty() {
		return this.getFacts().length==0 && this.getAttributes().length==0;
	}

	/**
	 * Returns list of all Moser objects in the spec Use for testing purposes.
	 */
	getAllObjects() {
		var output = [];
		Array.prototype.push.apply(output, this.getFacts());
		Array.prototype.push.apply(output, this.getAttributes());
		for (var __i_enFor0 = 0, __exp_enFor0 = this.getTraversalPath(), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var node = __exp_enFor0[__i_enFor0];
			this._getObjectsFromNode(node, output);
		}
		return output;
	}

	_getObjectsFromNode(node, objects) {
		Array.prototype.push.apply(objects, node.getAttributes());
		for (var __i_enFor0 = 0, __exp_enFor0 = node.getChildren(), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var childNode = __exp_enFor0[__i_enFor0];
			this._getObjectsFromNode(childNode, objects);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/MetricGeneratorSpec.js